'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDayEpoch = require('./xDayEpoch');

var _xDayEpoch2 = _interopRequireDefault(_xDayEpoch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return (0, _xDayEpoch2.default)(-1);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/yesterdayEpoch.js
// module id = 11
// module chunks = 0